export default __webpack_public_path__ + "static/media/card-back-square.9e7ff1bc.jpg";